<div [formGroup]="formGroup">
	<div class="field-row">
		<div class="field-row-title">
			Plow Label
		</div>
		<div class="field-row-element">
			<mat-form-field subscriptSizing="dynamic">
				<input matInput
					   cdkFocusInitial
					   formControlName="label">
			</mat-form-field>
		</div>
	</div>

    <div class="field-row">
        <div class="field-row-title">
            Connection Type
        </div>
        <div class="field-row-element">
            <mat-form-field subscriptSizing="dynamic">
                <mat-select formControlName="sensorConnectionType">
                    @for (type of sensorConnectionTypes; track type) {
                        <mat-option [value]="type">{{type}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>

	<app-input-connection-configuration formControlName="connection"
						   [availableInputs]="availableInputs()"
                           [isTwoWire]="isTwoWire()">
	</app-input-connection-configuration>

	@if (isTwoWire()) {
		<app-input-connection-configuration formControlName="twoWireOtherConnection"
							   [availableInputs]="availableInputs()"
                               [isTwoWire]="true"
							   label="Second Input">
		</app-input-connection-configuration>
	}
</div>
